import Token from '@/utils/Token';

export default {
    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/evidencia/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/evidencia/list${params}`, Token.getHeader());
    },
    listContrato(contratoId, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/evidencia/listContrato/${contratoId}${params}`, Token.getHeader());
    },
}